import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './SubmissionForm.css';
import axios from 'axios';
import Navbar from '../Navbar';
import Sidebar from '../Sidebar';
import Footer from '../Footer';
import getQuoteImage from '../../images/contact_us.png';

const GetQuote = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  const initialFormState = {
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    companyName: '',
    industry: '',
    serviceInterest: 'SEO',
    timeline: '',
    budgetRange: '',
    projectDescription: '',
    hearAboutUs: '',
  };
  const [formData, setFormData] = useState(initialFormState);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setError(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);

    try {
      const endpoint = process.env.REACT_APP_FORM_ENDPOINT;
      if (!endpoint) {
        setError('Form is not configured. Set REACT_APP_FORM_ENDPOINT to your form API URL.');
        return;
      }
      await axios.post(endpoint, { ...formData, category: 'Get Quote' }, {
        headers: { Accept: 'application/json' },
      });
      setSubmitted(true);
      setFormData(initialFormState);
    } catch (err) {
      setError(err.response?.data?.message || 'Something went wrong. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Sidebar isOpen={isOpen} toggle={toggle} />
      <Navbar toggle={toggle} />
      <div className="getquote-page">
        <div className="getquote-container">
          <div className="getquote-image-wrap">
            <img
              src={getQuoteImage}
              alt="Get in touch with Wiry for your digital marketing needs"
              className="getquote-image"
            />
            <div className="getquote-image-overlay">
              <h2>Let&apos;s grow together</h2>
              <p>Tell us about your project and we&apos;ll get back with a tailored quote.</p>
            </div>
          </div>

          <div className="getquote-form-wrap">
            {submitted ? (
              <div className="getquote-success">
                <div className="getquote-success-icon">✓</div>
                <h3>Thank you!</h3>
                <p>We&apos;ve received your request and will get back to you soon.</p>
                <Link to="/" className="getquote-back-link">Back to Home</Link>
              </div>
            ) : (
              <>
                <h1 className="getquote-title">Get a Quote</h1>
                <p className="getquote-intro">Fill in the form and we&apos;ll reach out with a custom proposal.</p>

                <form onSubmit={handleSubmit} className="getquote-form">
                  <div className="getquote-row">
                    <div className="form-field">
                      <label htmlFor="firstName">First Name *</label>
                      <input
                        type="text"
                        id="firstName"
                        name="firstName"
                        value={formData.firstName}
                        onChange={handleChange}
                        placeholder="John"
                        required
                      />
                    </div>
                    <div className="form-field">
                      <label htmlFor="lastName">Last Name *</label>
                      <input
                        type="text"
                        id="lastName"
                        name="lastName"
                        value={formData.lastName}
                        onChange={handleChange}
                        placeholder="Doe"
                        required
                      />
                    </div>
                  </div>

                  <div className="form-field">
                    <label htmlFor="email">Email *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="john@company.com"
                      required
                    />
                  </div>

                  <div className="form-field">
                    <label htmlFor="phoneNumber">Phone Number *</label>
                    <input
                      type="tel"
                      id="phoneNumber"
                      name="phoneNumber"
                      value={formData.phoneNumber}
                      onChange={handleChange}
                      placeholder="+1 (555) 000-0000"
                      required
                    />
                  </div>

                  <div className="form-field">
                    <label htmlFor="companyName">Company / Business name</label>
                    <input
                      type="text"
                      id="companyName"
                      name="companyName"
                      value={formData.companyName}
                      onChange={handleChange}
                      placeholder="Your company or brand"
                    />
                  </div>

                  <div className="form-field">
                    <label htmlFor="industry">Industry</label>
                    <input
                      type="text"
                      id="industry"
                      name="industry"
                      value={formData.industry}
                      onChange={handleChange}
                      placeholder="e.g. Restaurant, Retail, Real Estate"
                    />
                  </div>

                  <div className="form-field">
                    <label htmlFor="serviceInterest">What are you looking for? *</label>
                    <select
                      id="serviceInterest"
                      name="serviceInterest"
                      value={formData.serviceInterest}
                      onChange={handleChange}
                      required
                    >
                      <option value="SEO">SEO</option>
                      <option value="Social Media">Social Media</option>
                      <option value="Digital & Virtual Tours">Digital & Virtual Tours</option>
                      <option value="Website development">Website development</option>
                      <option value="Full marketing package">Full marketing package</option>
                      <option value="Not sure yet">Not sure yet</option>
                    </select>
                  </div>

                  <div className="form-field">
                    <label htmlFor="timeline">Preferred timeline</label>
                    <select
                      id="timeline"
                      name="timeline"
                      value={formData.timeline}
                      onChange={handleChange}
                    >
                      <option value="">Select timeline</option>
                      <option value="ASAP">ASAP</option>
                      <option value="1-3 months">1–3 months</option>
                      <option value="3-6 months">3–6 months</option>
                      <option value="Flexible">Flexible</option>
                    </select>
                  </div>

                  <div className="form-field">
                    <label htmlFor="budgetRange">Budget range (optional)</label>
                    <select
                      id="budgetRange"
                      name="budgetRange"
                      value={formData.budgetRange}
                      onChange={handleChange}
                    >
                      <option value="">Select range</option>
                      <option value="Under $1,000">Under $1,000</option>
                      <option value="$1,000 - $5,000">$1,000 – $5,000</option>
                      <option value="$5,000 - $15,000">$5,000 – $15,000</option>
                      <option value="$15,000+">$15,000+</option>
                      <option value="Prefer to discuss">Prefer to discuss</option>
                    </select>
                  </div>

                  <div className="form-field">
                    <label htmlFor="projectDescription">Tell us about your project and goals *</label>
                    <textarea
                      id="projectDescription"
                      name="projectDescription"
                      value={formData.projectDescription}
                      onChange={handleChange}
                      placeholder="What do you want to achieve? Current challenges? Any deadlines or must-haves?"
                      rows={4}
                      required
                    />
                  </div>

                  <div className="form-field">
                    <label htmlFor="hearAboutUs">How did you hear about us?</label>
                    <select
                      id="hearAboutUs"
                      name="hearAboutUs"
                      value={formData.hearAboutUs}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="Search">Search / Google</option>
                      <option value="Social media">Social media</option>
                      <option value="Referral">Referral</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>

                  {error && <p className="getquote-error">{error}</p>}

                  <button type="submit" className="getquote-submit" disabled={submitting}>
                    {submitting ? 'Sending…' : 'Submit'}
                  </button>
                </form>
              </>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default GetQuote;
